import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/joy";
import { theme } from "styles/theme";
import { AgentLivingLogo } from "./AgentLivingLogo";

// 응답 대기 중 문구. 거리두기(MBCT/CBT) 톤의 위트.
// 한 번의 running 동안 하나만 고정으로 보여준다 (마운트 시 1개 선택).
const PHRASES = [
  "생각을 굴리는 중",
  "곰곰이 들여다보는 중",
  "활동지를 매만지는 중",
  "문장의 숨을 고르는 중",
  "마음을 살피는 중",
  "생각의 매듭을 푸는 중",
  "아이디어를 살짝 발효시키는 중",
  "문장에 온도를 맞추는 중",
  "활동지의 리듬을 재는 중",
  "문맥의 실마리를 찾는 중",
];

// 메시지 영역 하단의 "응답 받는 중" 상태 줄. 마운트 시점부터 경과 초를 센다.
// 문구는 마운트당 1개 고정 + shimmer, 아이콘은 커졌다 작아지는 pulse.
export function ThinkingIndicator() {
  const startedAtRef = useRef(Date.now());
  // 마운트당 1회만 선택 (running 중에는 안 바뀜).
  const [phrase] = useState(
    () => PHRASES[Math.floor(Math.random() * PHRASES.length)]
  );
  const [elapsedSec, setElapsedSec] = useState(0);

  useEffect(() => {
    const tick = setInterval(() => {
      setElapsedSec(Math.floor((Date.now() - startedAtRef.current) / 1000));
    }, 1000);
    return () => clearInterval(tick);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        px: "8px",
        py: "4px",
        fontSize: "12px",
        color: theme.vars.palette.Content.Weak,
        animation: "fadeIn 0.2s ease",
        "@keyframes fadeIn": {
          from: { opacity: 0 },
          to: { opacity: 1 },
        },
      }}
    >
      {/* 아이콘 — 커졌다 작아지는 pulse */}
      <Box
        sx={{
          width: 18,
          height: 18,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          transformOrigin: "center",
          animation: "agentIndicatorPulse 1.6s ease-in-out infinite",
          "@keyframes agentIndicatorPulse": {
            "0%, 100%": { transform: "scale(0.82)" },
            "50%": { transform: "scale(1.12)" },
          },
        }}
      >
        <AgentLivingLogo size={11} active />
      </Box>

      {/* 문구 — shimmer (밝은 sweep 이 흐름) */}
      <Box
        component="span"
        sx={{
          fontWeight: 600,
          backgroundImage: `linear-gradient(90deg, ${theme.vars.palette.Content.Weak} 0%, ${theme.vars.palette.Content.Weak} 35%, ${theme.vars.palette.Content.Strong} 50%, ${theme.vars.palette.Content.Weak} 65%, ${theme.vars.palette.Content.Weak} 100%)`,
          backgroundSize: "220% 100%",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
          WebkitTextFillColor: "transparent",
          animation: "agentShimmer 2.2s linear infinite",
          "@keyframes agentShimmer": {
            from: { backgroundPosition: "220% 0" },
            to: { backgroundPosition: "-220% 0" },
          },
        }}
      >
        {phrase}…
      </Box>

      {/* 경과 시간 — 정적 */}
      <Box
        component="span"
        sx={{
          fontFamily:
            "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
          fontSize: "11px",
        }}
      >
        ({elapsedSec}s)
      </Box>
    </Box>
  );
}
